import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

let app;
let auth;
let db;
let storage;
const database = null; // Realtime Database not used in this project

try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  initializeFirestore(app, {
    experimentalForceLongPolling: true,
    useFetchStreams: false
  });
  db = getFirestore(app);
  storage = getStorage(app);
  console.log('Firebase initialized successfully for project:', process.env.REACT_APP_FIREBASE_PROJECT_ID);
} catch (error) {
  console.error('Firebase initialization error:', error);
}

export { app, auth, db, storage, database };
export default app;
